import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'dva'
import CategoriesSection from '../CategoriesSection'
import GHAnimatedLogo from '../../../../assets/svg/GHAnimatedLogo'
import LayersSearchBox from '../LayersSearchBox'
import SidebarBody from '../../SidebarBody'
import styles from '../LayersContent.module.scss'
function FavoriteLayersTabContent(props) {
	return (
		<>
			<LayersSearchBox assetsUrl={props.assetsUrl} layers={props.favoriteLayers} dispatch={props.dispatch} />
			<SidebarBody>
				{props.allLayersLoading ? (
					<div className={styles.ghLoader}>
						<GHAnimatedLogo width={72} height={108} />
						<p>Loading Layers...</p>
					</div>
				) : (
					<>
						{props.favoriteLayers.length > 0 ? (
							<div className={styles.stateLayerList}>
								<div className={styles.layerListTitle}>
									<h3>Favorites</h3>
								</div>
								{props.favoriteLayers.map((favoriteObj, i) => {
									return (
                    <CategoriesSection
                    categories={favoriteObj.categories}
                    key={i}
                    stateName={favoriteObj.stateName}
                    />
                  )
								})}
							</div>
						) : (
							<div className={styles.stateLayerList}>
								<div className={styles.layerListTitle}>
									<h3>No Favorites Exist</h3>
								</div>
							</div>
						)}
					</>
				)}
			</SidebarBody>
		</>
	)
}

FavoriteLayersTabContent.propTypes = {
  assetsUrl: PropTypes.string,
	allLayersLoading: PropTypes.bool,
	favoriteLayers: PropTypes.array,
}

export default connect((model) => {
	const { config } = model.app
	const { allLayersLoading, layersByEvent, layersByState, preferences } = model.layers
	const allLayers = [...layersByEvent, ...layersByState]
	const favoriteLayers = allLayers.filter(al => preferences.favorites.states.includes(al.stateName.replace(' ', '_')))

	return {
		assetsUrl: config.GH_ASSETS_CLOUDFRONT_URL,
		allLayersLoading,
		favoriteLayers,
	}
})(FavoriteLayersTabContent)
